<template>
  <v-dialog v-model="show" max-width="570">
    <v-card>
      <v-card-title class="document-values-title">{{ $t('documents.allValues') }}</v-card-title>
      <v-card-text>
        <v-list v-if="fields.length" dense>
          <v-list-item v-for="field in fields" :key="field.key">
            <v-list-item-content>
              <v-list-item-title>{{ field.label }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action-text>{{ displayValue(field.value) }}</v-list-item-action-text>
          </v-list-item>
        </v-list>
        <div v-else class="text-center">{{ $t('product.custom.noCustoms') }}</div>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn block color="secondary" tile @click="show = false">
          {{ $t('documents.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DocumentValuesDialog',
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      fields: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      displayValue(value) {
        return value === null || value === undefined || value === '' ? '-' : value
      },
    },
  }
</script>

<style scoped>
  /* Vuetify's .v-card__title defaults to word-break: break-all, which splits a long title
     mid-word. Wrap between words instead and keep the title centered. */
  .document-values-title {
    justify-content: center;
    text-align: center;
    word-break: normal;
  }
</style>
